var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',_vm._g(_vm._b({attrs:{"appear":_vm.appear}},'transition',_vm.transitionClasses,false),_vm.hooks),[(!!_vm.$slots.default)?_c(_vm.tag,{key:_vm.selectedComponent,tag:"component",class:_vm.baseClass},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }